export enum Operation {
	ADD = 'ADD',
	REMOVE = 'REMOVE',
}
